import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import cn from 'classnames';

import FullScreenPage from './FullScreenPage';
import Header from './Header';
import Footer from './Footer';
import Scroller from './Scroller';
// import HeroLetter from './HeroLetter';
import LandscapeOverlay from './LandscapeOverlay';

import routes from '../routes';

import styles from './style.css';

import '../styles/index.css';
import withMeta from '../HOC/withMeta';

/* eslint-disable import/no-mutable-exports */
let App = withRouter(({ location: { pathname } }) => (
  <FullScreenPage>
    <Header />
    <main
      className={cn(styles.main, {
        [styles.main__flow]: pathname === '/contact'
      })}
    >
      {/* <Route component={HeroLetter} /> */}
      <Switch>
        {routes.map(({ key, path, exact, component, meta }) => (
          <Route
            key={key}
            path={path}
            exact={exact}
            component={withMeta({ path, ...meta })(component)}
          />
        ))}
      </Switch>
    </main>
    <Footer />
    <Scroller />
    <LandscapeOverlay />
  </FullScreenPage>
));
/* eslint-enable import/no-mutable-exports */

if (process.env.NODE_ENV === 'development') {
  /* eslint-disable global-require */
  const { hot } = require('react-hot-loader');
  /* eslint-enable global-require */

  App = hot(module)(App);
}

export default App;
